import { render, staticRenderFns } from "./NshopStatistics.vue?vue&type=template&id=6b296032&scoped=true&"
import script from "./NshopStatistics.vue?vue&type=script&lang=js&"
export * from "./NshopStatistics.vue?vue&type=script&lang=js&"
import style0 from "./NshopStatistics.vue?vue&type=style&index=0&id=6b296032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b296032",
  null
  
)

export default component.exports